// extracted by mini-css-extract-plugin
export default {"root":"footer___root___f322c0d6","logo":"footer___logo___ae4274e3","legal":"footer___legal___caa1ec56","social":"footer___social___c66b8645","links":"footer___links___b87e21e1"};